<?php
\Core\View::$template = function () {
    $html = '

    <nav class="navbar navbar-expand-lg fixed-top nav-transparent">
      <div class="container">
        <a class="navbar-brand" href="#" style="height: 90px;">
          <img src="' . IMAGE_ASSET_PREFIX . 'app/Default/Assets/images/logg.png" height="80">
        </a>
          <ul class="navbar-nav ml-auto">
            <li class="nav-item active">
              <a class="nav-link" href="#">
                Invite
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link go-register-hiring" href="/register/hiring">Looking for Staff?</a>
            </li>
            <li class="nav-item">
              <a class="nav-link go-register-employee" href="/register/employee">Looking for Work?</a>
            </li>
            <li class="nav-item">
              <a class="nav-link nav-signup go-login-page" href="/login" >Login</a>
            </li>
          </ul>
      </div>
    </nav>

    <section class="general top-bg">
      <div class="container">
        <div class="row">
          <div class="col-lg-5 col-md-5 col-xs-12 col-5 top-info">
            <p class="sub-head-small">
              Tech Friendly Recruitment
            </p>
          </div>
        </div>
      </div>
    </section> ';

    $html = $html . '

    <section class="section-control  text-center">
      <div class="container">
        <h2 class="text-center">Login</h2>
        <div class="row clearfix"> ' ;

    $html = $html . '<div class="row">' ;
    $html = $html . '  <div class="col-sm-6 text-center">' ;
    $html = $html . '    <div class="btn btn-success"><span class="go-login-page">Log me in</span></div>' ;
    $html = $html . '  </div>' ;
    $html = $html . '</div>' ;

    $html = $html . '
      </div>
    </section>';

    $html = $html . '

    <section class="section-control  text-center">
      <div class="container">
        <h2 class="text-center">Register</h2>
        <div class="row clearfix"> ' ;

    $html = $html . '<div class="row">' ;
    $html = $html . '  <div class="col-sm-6 text-center">' ;
    $html = $html . '    <div class="btn btn-info"><span class="go-register-employee">I&apos;m Looking for Work</span></div>' ;
    $html = $html . '  </div>' ;
    $html = $html . '  <div class="col-sm-6 text-center">' ;
    $html = $html . '    <div class="btn btn-info"><span class="go-register-hiring">I&apos;m Hiring Staff</span></div>' ;
    $html = $html . '  </div>' ;
    $html = $html . '</div>' ;

    $html = $html . '
      </div>
    </section>';


    $html = $html . '

    <section class="footer-bottom">
      <div class="container">
        <div class="row clearfix">
          <div class="col-md-3 col-3 col-xs-12 col-lg-3">
            © 2023 Video Interviews
          </div>
        </div>
      </div>
    </section>';

    return $html;
};




// WEBPACK FOOTER //
// app/LandingPage/View/mobile/LandingPage.php